// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-lobby {
  overflow-x: hidden;
  background-color: #fff;
  color: var(--text-color);
}
.mobile-lobby .mobile-gallery-casino {
  display: flex;
  flex-direction: column;
}
@media (orientation: landscape) and (min-width: 768px) {
  .mobile-lobby .mobile-gallery-casino {
    padding-left: calc(var(--sar, 0px) / 1.5);
    padding-right: calc(var(--sar, 0px) / 1.5);
  }
}
.mobile-lobby .mobile-gallery-casino .app-footer-container {
  transform: translateY(12px);
}
.mobile-lobby .mobile-gallery-casino .mobile-gallery-block-container {
  border-top: 0.5px solid var(--ion-color-tertiary);
}
.mobile-lobby .mobile-gallery-casino .mobile-gallery-block {
  min-height: calc(var(--vh, 1vh) * 10);
  display: flex;
  width: 100%;
  align-content: stretch;
  padding: 0.75rem 0;
}
.mobile-lobby .mobile-gallery-casino .mobile-gallery-block .mobile-image-container {
  display: flex;
  align-items: center;
}
.mobile-lobby .mobile-gallery-casino .mobile-gallery-block .mobile-image-container .mobile-image-tile {
  width: 75px;
  height: 75px;
  border: solid 1px black;
  border-radius: 10px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
}
.mobile-lobby .mobile-gallery-casino .mobile-gallery-block .details-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 0.6rem;
  flex-grow: 2;
  color: var(--text-color);
}
.mobile-lobby .mobile-gallery-casino .mobile-gallery-block .details-container .game-title-landscape {
  font-size: 1rem;
  font-weight: bold;
  font-family: "Montserrat", sans-serif;
  margin: 0%;
  padding: 0%;
  white-space: normal;
}
@media (orientation: portrait) {
  .mobile-lobby .mobile-gallery-casino .mobile-gallery-block .details-container .game-title-landscape {
    display: none;
  }
}
.mobile-lobby .mobile-gallery-casino .mobile-gallery-block .details-container .game-title-portrait {
  font-size: 1rem;
  font-weight: bold;
  font-family: "Montserrat", sans-serif;
  margin: 0%;
  padding: 0%;
  white-space: normal;
}
@media (orientation: landscape) {
  .mobile-lobby .mobile-gallery-casino .mobile-gallery-block .details-container .game-title-portrait {
    display: none;
  }
}
.mobile-lobby .mobile-gallery-casino .mobile-gallery-block .details-container .game-subtitle {
  font-size: 0.8rem;
  margin: 1.5px;
  padding: 0%;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  text-transform: capitalize;
}
.mobile-lobby .mobile-gallery-casino .mobile-gallery-block .mobile-icons-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 18%;
}
.mobile-lobby .mobile-gallery-casino .mobile-gallery-block .mobile-icons-container .mobile-icons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.content-container {
  min-height: 6rem;
  background-color: var(--ion-color-light);
}
.content-container .no-games-card-container {
  display: flex;
  padding-top: -50px;
  max-width: 80%;
  margin-left: 10%;
  background-color: var(--ion-color-light);
  padding: 0%;
  justify-content: center;
  overflow: hidden;
}
.content-container .no-games-card-container .no-games-card {
  color: var(--ion-color-dark);
  display: flex;
  flex-direction: column;
  margin-top: 4px;
}
.content-container .no-games-card-container .no-games-card .title {
  font-weight: bold;
  text-align: center;
}
.content-container .no-games-card-container .no-games-card .subtitle {
  font-weight: bold;
  text-align: center;
}

.jackpot-mobile-counter {
  padding: 3px 0px;
}

.jackpot-mobile-top {
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.jackpot-mobile-bottom {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

jackpot-counter {
  position: absolute;
  z-index: 998;
  background: var(--ion-color-jackpot);
  color: #FFFFFF;
  font-weight: bold;
  padding: 0.375rem;
  left: 0;
  text-align: center;
  width: 100%;
  font-family: var(--font-primary);
}

ion-icon {
  font-size: 1.5rem;
}

ion-icon[name*=heart] {
  color: var(--fav-icon-color);
}

.jackpot-counter-top {
  top: 0;
}

.jackpot-counter-bottom {
  bottom: 0;
}

.heart-icon-desktop {
  z-index: 1000 !important;
  bottom: 3px !important;
  right: 7px !important;
}
@media (max-width: 480px) {
  .heart-icon-desktop {
    right: 3px !important;
  }
}

.info-icon-desktop {
  z-index: 1000 !important;
  top: 3px !important;
}

.other-games-title h1 {
  font-size: 1.25rem;
  margin: 0.65rem 0.25rem 0.25rem 0.5rem;
}

@media screen and (max-width: 576px) {
  .gallery-casino ion-icon {
    font-size: 1.1rem;
  }
  .gallery-casino .heart-icon-desktop {
    bottom: 7px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/casino-lobby/gallery-casino/gallery-casino.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,sBAAA;EACA,wBAAA;AACJ;AAKI;EACI,aAAA;EACA,sBAAA;AAHR;AAKQ;EAJJ;IAKQ,yCAAA;IACA,0CAAA;EAFV;AACF;AAIQ;EACI,2BAAA;AAFZ;AAKQ;EACI,iDAAA;AAHZ;AAMQ;EACI,qCAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AAJZ;AAMY;EACI,aAAA;EACA,mBAAA;AAJhB;AAMgB;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;AAJpB;AAQY;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,YAAA;EACA,wBAAA;AANhB;AAQgB;EACI,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AANpB;AAQoB;EARJ;IASQ,aAAA;EALtB;AACF;AAQgB;EACI,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AANpB;AAQoB;EARJ;IASQ,aAAA;EALtB;AACF;AAQgB;EACI,iBAAA;EACA,aAAA;EACA,WAAA;EACA,qCAAA;EACA,gBAAA;EACA,0BAAA;AANpB;AAWY;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;AAThB;AAWgB;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AATpB;;AAoBA;EACI,gBAAA;EACA,wCAAA;AAjBJ;AAmBI;EACI,aAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,wCAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AAjBR;AAmBQ;EACI,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AAjBZ;AAmBY;EACI,iBAAA;EACA,kBAAA;AAjBhB;AAoBY;EACI,iBAAA;EACA,kBAAA;AAlBhB;;AAwBA;EACI,gBAAA;AArBJ;;AAwBA;EACI,4BAAA;EACA,2BAAA;AArBJ;;AAwBA;EACI,+BAAA;EACA,8BAAA;AArBJ;;AAwBA;EACI,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,gCAAA;AArBJ;;AAwBA;EACI,iBAAA;AArBJ;;AAwBA;EACI,4BAAA;AArBJ;;AAwBA;EACI,MAAA;AArBJ;;AAwBA;EACI,SAAA;AArBJ;;AAwBA;EACI,wBAAA;EACA,sBAAA;EACA,qBAAA;AArBJ;AAuBI;EALJ;IAMQ,qBAAA;EApBN;AACF;;AAuBA;EACI,wBAAA;EACA,mBAAA;AApBJ;;AAwBI;EACI,kBAAA;EACA,sCAAA;AArBR;;AA0BI;EACI;IACI,iBAAA;EAvBV;EAyBM;IACI,sBAAA;EAvBV;AACF","sourcesContent":[".mobile-lobby {\n    overflow-x: hidden;\n    background-color: #fff;\n    color: var(--text-color);\n\n   \n\n\n\n    .mobile-gallery-casino {\n        display: flex;\n        flex-direction: column;\n\n        @media (orientation: landscape) and (min-width: 768px) {\n            padding-left: calc(var(--sar, 0px) / 1.5);\n            padding-right: calc(var(--sar, 0px) / 1.5);\n        }\n        \n        .app-footer-container {\n            transform: translateY(12px);\n        }\n\n        .mobile-gallery-block-container {\n            border-top: 0.5px solid var(--ion-color-tertiary);\n        }\n\n        .mobile-gallery-block {\n            min-height: calc(var(--vh, 1vh) * 10);\n            display: flex;\n            width: 100%;\n            align-content: stretch;\n            padding: 0.75rem 0;\n\n            .mobile-image-container {\n                display: flex;\n                align-items: center;\n\n                .mobile-image-tile {\n                    width: 75px;\n                    height: 75px;\n                    border: solid 1px black;\n                    border-radius: 10px;\n                    background-size: cover;\n                    background-repeat: no-repeat;\n                    background-position: center;\n                    position: relative;\n                }\n            }\n\n            .details-container {\n                display: flex;\n                justify-content: center;\n                flex-direction: column;\n                align-items: flex-start;\n                padding-left: .6rem;\n                flex-grow: 2;\n                color: var(--text-color);\n\n                .game-title-landscape {\n                    font-size: 1rem;\n                    font-weight: bold;\n                    font-family: 'Montserrat', sans-serif;\n                    margin: 0%;\n                    padding: 0%;\n                    white-space: normal;\n\n                    @media (orientation: portrait) {\n                        display: none;\n                    }\n                }\n\n                .game-title-portrait {\n                    font-size: 1rem;\n                    font-weight: bold;\n                    font-family: 'Montserrat', sans-serif;\n                    margin: 0%;\n                    padding: 0%;\n                    white-space: normal;\n\n                    @media (orientation: landscape) {\n                        display: none;\n                    }\n                }\n\n                .game-subtitle {\n                    font-size: .8rem;\n                    margin: 1.5px;\n                    padding: 0%;\n                    font-family: 'Montserrat', sans-serif;\n                    font-weight: 500;\n                    text-transform: capitalize;\n                    \n                }\n            }\n\n            .mobile-icons-container {\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n                min-width: 18%;\n\n                .mobile-icons {\n                    display: flex;\n                    flex-direction: row;\n                    justify-content: space-between;\n\n                }\n            }\n        }\n\n    }\n}\n\n\n\n.content-container {\n    min-height: 6rem;\n    background-color: var(--ion-color-light);\n\n    .no-games-card-container {\n        display: flex;\n        padding-top: -50px;\n        max-width: 80%;\n        margin-left: 10%;\n        background-color: var(--ion-color-light);\n        padding: 0%;\n        justify-content: center;\n        overflow: hidden;\n\n        .no-games-card {\n            color: var(--ion-color-dark);\n            display: flex;\n            flex-direction: column;\n            margin-top: 4px;\n\n            .title {\n                font-weight: bold;\n                text-align: center;\n            }\n\n            .subtitle {\n                font-weight: bold;\n                text-align: center;\n            }\n        }\n    }\n}\n\n.jackpot-mobile-counter {\n    padding: 3px 0px;\n}\n\n.jackpot-mobile-top {\n    border-top-right-radius: 8px;\n    border-top-left-radius: 8px;\n}\n\n.jackpot-mobile-bottom {\n    border-bottom-right-radius: 8px;\n    border-bottom-left-radius: 8px;\n}\n\njackpot-counter {\n    position: absolute;\n    z-index: 998;\n    background: var(--ion-color-jackpot);\n    color: #FFFFFF;\n    font-weight: bold;\n    padding: 0.375rem;\n    left: 0;\n    text-align: center;\n    width: 100%;\n    font-family: var(--font-primary);\n}\n\nion-icon {\n    font-size: 1.5rem;\n}\n\nion-icon[name*=\"heart\"] {\n    color: var(--fav-icon-color);\n}\n\n.jackpot-counter-top {\n    top: 0;\n}\n\n.jackpot-counter-bottom {\n    bottom: 0;\n}\n\n.heart-icon-desktop {\n    z-index: 1000 !important;\n    bottom: 3px !important;\n    right: 7px !important;\n\n    @media (max-width: 480px) {\n        right: 3px !important;\n    }\n}\n\n.info-icon-desktop {\n    z-index: 1000 !important;\n    top: 3px !important;\n}\n\n.other-games-title {\n    h1 {\n        font-size: 1.25rem;\n        margin: 0.65rem 0.25rem 0.25rem 0.5rem;\n    }\n}\n\n.gallery-casino {\n    @media screen and (max-width: 576px) {\n        ion-icon {\n            font-size: 1.1rem;\n        }\n        .heart-icon-desktop {\n            bottom: 7px !important;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
